<template>
  <div class="customer-header d-flex flex-column">
    <Transition>
      <div
        v-if="customer"
        class="full-width header-container"
        :class="{ archived: customer.archived }"
      >
        <div class="d-flex justify-content-between">
          <WarningMessage v-if="customer.archived" class="warning-banner">
            <span>ARCHIVED ACCOUNT</span>
          </WarningMessage>
          <CustomerInfo
            :customer="customer"
            show-edit-button
            @edit-profile="toggleModal('editProfile')"
            @refresh-tax-info="handleRefreshTaxInfo"
          />
        </div>
      </div>
      <div v-else class="d-flex align-items-center justify-content-center">
        <Spinner message="Loading customer details..." class="text-grey" />
      </div>
    </Transition>
    <CustomerModal
      v-if="editProfile"
      :customer="customer"
      @hide-modal="toggleModal('editProfile')"
      @save-success="handleSaveSuccess"
    />
  </div>
</template>

<script lang="ts">
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { mapState } from "vuex";
import { EventBus } from "@/lib/event_bus";

import Spinner from "@/components/Spinner.vue";
import CustomerInfo from "@/Customer/CustomerInfo.vue";
import CustomerModal from "@/Customer/CustomerModal/CustomerModal.vue";

export default {
  components: {
    CustomerModal,
    Spinner,
    CustomerInfo,
    WarningMessage
  },
  emits: ["fetch-user"],
  data() {
    return {
      editProfile: false
    };
  },
  computed: {
    ...mapState({
      customer: "currentUser"
    })
  },
  methods: {
    // NOTE: Used on CustomerShow.vue to launch the customer modal from a query parameter
    showEditModal() {
      this.editProfile = true;
    },
    toggleModal(modal) {
      this[modal] = !this[modal];
    },
    handleRefreshTaxInfo() {
      this.$emit("fetch-user");
    },
    handleSaveSuccess() {
      this.$emit("fetch-user");
      EventBus.$emit("refresh-invoice");
      EventBus.$emit("refresh-quote");
    }
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  flex-wrap: wrap;
  position: relative;
}

.warning-banner {
  position: absolute;
  top: calc(var(--sera-main-padding) * -1);
  left: calc(var(--sera-main-padding) * -1);
  right: calc(var(--sera-main-padding) * -1);
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.archived {
  padding-top: 30px;
}
</style>
